<template>
  <div id="TermsConditions" :class="{ active: modalShow }">
    <div class="content">
      <div class="holder">
        <div class="top">terms and conditions</div>
        <div class="bottom">
          <p>
            By clicking the box below I acknowledge that I am agreeing to the
            current terms and conditions associated with being a Pistons ONE
            member.
          </p>
          <div class="check">
            <div class="box" @click="checked = !checked">
              <span v-if="checked">X</span>
            </div>
            <h1>I agree</h1>
          </div>
          <div
            class="submit"
            :class="{ active: checked }"
            @click="submitForm()"
            v-if="activePurl !== '/rick.amos.0000'"
          >
            submit
          </div>
          <div
            class="submit"
            :class="{ active: checked }"
            @click="rickSubmit()"
            v-else
          >
            submit
          </div>
          <a
            href="https://www.nba.com/pistons/terms"
            target="_blank"
            @click="store.dispatch('purl/purlTracking', 'Terms & Conditions')"
            >Terms & Conditions</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

export default {
  name: "TermsConditions",
  props: ["modalShow", "purlData"],
  emits: ["showModal", "closeModal"],
  data() {
    return {
      checked: false,
      activePurl: null,
    };
  },
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
    });

    return { ...toRefs(state), store };
  },
  methods: {
    async submitForm() {
      if (this.checked == true) {
        const purl = this.$route.path.split("/")[1];

        const response = await axios.post(
          process.env.VUE_APP_API_URL + "/api/router/Forms.php",
          {
            prefix: process.env.VUE_APP_API_DB_PREFIX,
            action: "acceptTerms",
            accountId: this.purl.accountId,
            timestamp: new Date(),
          }
        );

        this.$store.dispatch(
          "purl/purlTracking",
          "Accepted Terms & Conditions"
        );
        this.$emit("closeModal");
      }
    },
    rickSubmit() {
      this.$emit("closeModal");
    },
  },
  mounted() {
    this.activePurl = this.$route.path;

    if (
      this.purlData.acceptedTerms == undefined ||
      this.purlData.acceptedTerms == null ||
      this.$route.path == "/rick.amos.0000"
    ) {
      this.$emit("showModal");
    }
  },
};
</script>

<style lang="scss" scoped>
#TermsConditions {
  position: fixed;
  top: 50%;
  left: 50%;
  height: 0;
  width: 0;
  backdrop-filter: blur(10px);
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  z-index: 39;
  &.active {
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.48);
    .holder {
      position: relative;
      width: 600px;
      max-width: 90%;
      min-height: 309px;
      background-image: url("~@/assets/images/header/pop-up-bg2.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      .top {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 54px;
        width: 100%;
        padding-left: 18px;
        border-bottom: 1px solid #b0b7bc;
        font-family: Abolition;
        font-weight: normal;
        font-size: 28px;
        line-height: 27px;
        letter-spacing: normal;
        color: #000a12;
        text-transform: uppercase;
      }
      .bottom {
        display: flex;
        flex-direction: column;
        padding: 36px 50px 30px 50px;
        p {
          font-family: DINPro;
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: normal;
          color: #000a12;
        }
        .check {
          display: flex;
          flex-direction: row;
          align-items: center;
          .box {
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            height: 20px;
            width: 20px;
            border: 1px solid #b0b7bc;
            background: linear-gradient(180deg, #fcfcfc 0%, #fafafa 100%);
            box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.47);
            cursor: pointer;
          }
          h1 {
            font-family: Abolition;
            font-weight: normal;
            font-size: 16px;
            line-height: 19px;
            letter-spacing: normal;
            color: #000a12;
            margin: 2px 0 0 10px;
          }
        }
        .submit {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 38px;
          width: 128px;
          font-family: Abolition;
          font-size: 20px;
          letter-spacing: 0;
          line-height: 24px;
          color: #ffffff;
          text-transform: uppercase;
          background-color: #b0b7bc;
          margin: 20px 0 25px 0;
          transition: background-color 0.3s ease-in-out;
          &.active {
            background-color: #de1e35;
            transition: background-color 0.3s ease-in-out;
            cursor: pointer;
          }
        }
        a {
          font-family: "DIN Pro";
          font-weight: normal;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 24px;
          color: #000a12;
        }
      }
    }
  }
}
</style>